import { apiSlice } from "../../../../../app/apiSlice";
import { MenuNeto, MenuNetoDTO, MenuNetoList } from "../../../../../typesSite/menuneto/MenuNeto";


import configSiteUrls from "../../../configs/configSiteUrls";

//usei o menuNeto como base

const endpointUrl = configSiteUrls.SITE_MENU_NETO_EP;

function getMenuNetos({ search }: { search: string }) {
  return {
    url: `${endpointUrl}/filter?search=${search}`,
    method: "GET",
  };
}

function addMenuNeto(obj: MenuNeto) {
  return {
    url: `${endpointUrl}/create`,
    method: "POST",
    body: obj,
  };
}

function deleteMenuNeto({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: "DELETE",
  };
}
function getMenuNeto(id: string) {
  if (!id) {
    return {
      url: "",
      method: "",
    };
  }

  return {
    url: `${endpointUrl}/${id}`,
    method: "GET",
  };
}
/** */

export const menuNetoApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getMenuNetos: query<MenuNetoList[], { search: string }>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getMenuNetos,
      providesTags: ["MenuNeto"],
    }),

    getMenuNeto: query<MenuNeto, string>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getMenuNeto,
      providesTags: ["MenuNeto"],
    }),
    addMenuNeto: mutation<void, MenuNetoDTO>({
      query: addMenuNeto,
      invalidatesTags: ["MenuNeto"],
    }),
    deleteMenuNeto: mutation<void, { id: string }>({
      query: deleteMenuNeto,
      invalidatesTags: ["MenuNeto"],
    }),
  }),
});
export const {
  useGetMenuNetosQuery,
  useGetMenuNetoQuery,
  useAddMenuNetoMutation,
  useDeleteMenuNetoMutation,
} = menuNetoApiSlice;
